export default function MapLoader () { 
    return new Promise((resolve, reject) => {
      if (window.AMap) {
        resolve(window.AMap)
      } else {
        var script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = 'https://webapi.amap.com/maps?v=1.3&callback=initAMap&key=523bf343cd22028caafd86036feabfe3&plugin=AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder'
        script.onerror = reject
        document.head.appendChild(script)
      }
      window.initAMap = () => {
        resolve(window.AMap)
      }
    })
  }
